import React from 'react';
import {default as CommonIcon} from '@spothero/ui/icon';
import IconPropTypes from '@spothero/ui/icon-prop-types';
import ICONS from './icon-defs';

const Icon = props => {
    return (
        <CommonIcon
            {...props}
            iconDefinitions={ICONS}
        />
    );
};

Icon.propTypes = IconPropTypes;

export default Icon;
